// generateSlug.js
const generateSlug = (project) => {
  const serv = project?.property_service;
  const category = project?.property_category;
  const location = project?.property_location;
  const title = project?.title;
  const redirection = project?.redirection;
  const id = redirection.split("-")[0];

  let url = `${
    serv === "sell" && category === "commercial"
      ? "buy-in"
      : serv === "sell"
      ? "buy"
      : serv === "rent" && category === "commercial"
      ? "lease-in"
      : serv
  }-${title}-${location}-${redirection}`;

  let type = `${id === "pid" ? "project" : "property"}`;

  function toSlug(text = "") {
    return text
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }
  return `/${type}/${toSlug(url)}`;
};

export default generateSlug;
